













































































































import Vue from 'vue'
import {
  RecommendedFacility,
  CampaignFacility,
  buildFacilityPath,
} from '@/core/Facilities'
import { FavoriteFacility } from '@/core/Favorites'
import Icon from '@/components/globals/Icon.vue'
import FavoriteButton from '@/components/globals/basics/Favorite/FavoriteButton.vue'
import Stars from '@/components/globals/basics/Rating/Stars.vue'

export default Vue.extend({
  name: 'FacilityCardAlt',
  components: {
    Icon,
    FavoriteButton,
    Stars,
  },
  filters: {
    formatScore(score: number) {
      const floatValue = score - Math.floor(score)
      // 小数点以下がない場合は.0をsuffixする
      return floatValue === 0 ? `${score}.0` : score
    },
    truncate(str: string, size: number, suffix: string = '…') {
      let b = 0
      for (let i = 0; i < str.length; i++) {
        b += str.charCodeAt(i) <= 255 ? 1 : 2
        if (b > size) {
          return str.substr(0, i) + suffix
        }
      }
      return str
    },
  },
  props: {
    rank: {
      type: Number as () => number | null,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    facility: {
      type: Object as () =>
        | RecommendedFacility
        | CampaignFacility
        | FavoriteFacility,
      default: () => ({} as RecommendedFacility),
    },
    type: {
      type: String as () => 'default' | 'pricing',
      default: 'default',
    },
    isFavorited: {
      type: Boolean,
      default: false,
    },
    pcImgLarge: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    facilityPath(): string {
      return (this.facility as FavoriteFacility).isOnline
        ? `/online_facilities/${this.facility.id}`
        : buildFacilityPath(this.facility)
    },
  },
  methods: {
    handleFavoriteClick() {
      this.$emit('favorited', this.facility.id, !this.isFavorited)
    },
  },
})
